"use client"

import { create } from "zustand"

type State<T> = {
  handoff: T | undefined
  setHandoff: (_new: T) => void
}

export const useHandoffStore = create<State<unknown>>(set => ({
  handoff: undefined,
  setHandoff: (_new: unknown) => {
    set(() => ({
      handoff: _new,
    }))
  },
}))

type UseHandoffMutatorOpts = {
  enabled?: boolean
}

/**
 * Hook for controls over setting the handoff
 *
 * @param opts - UseHandoffMutatorOpts
 * @returns
 */
export const useHandoffMutator = <T>({
  enabled = true,
}: UseHandoffMutatorOpts = {}) => {
  const setHandoff = useHandoffStore(state => state.setHandoff)

  function set(thingToHandoff: T) {
    if (!enabled) {
      return
    }

    setHandoff(thingToHandoff)
  }

  return set
}

/**
 * Grab the handoff from the store without clearing it
 *
 * @returns - items: Items | undefined
 */
export const useHandoff = <T>(): T | undefined => {
  const handoff = useHandoffStore(state => state.handoff as T | undefined)
  return handoff
}
